import { render, staticRenderFns } from "./StaticVerticalMenu.vue?vue&type=template&id=03ff5210&scoped=true&"
import script from "./StaticVerticalMenu.vue?vue&type=script&lang=js&"
export * from "./StaticVerticalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff5210",
  null
  
)

export default component.exports